<template>
  <base-form :loading="loading" class="noprogress">
    <template v-slot:header>
      {{ $t('renew_mobile_number') }}
    </template>
   <base-input-phone
      :default-country-code="phoneNumberInfo.countryCode"
      v-model="phoneNumberInfo.phone"
      @update="onUpdatePhone"
      :error="$v.phone.$dirty && $v.phone.$invalid"
      :valid="!$v.phone.$invalid"/>
    <base-button @click.prevent="onSubmit"/>
  </base-form>
</template>

<script>
import { BaseInputPhone, BaseForm } from 'qic-components'
export default {
  name: 'MobilePhone',
  components: {
    BaseInputPhone,
    BaseForm
  },
  data () {
    return {
      loading: false,
      phoneNumberInfo: {
        phone: null,
        formattedPhone: null,
        countryCode: 'QA',
        isValidLength: false
      }
    }
  },
  methods: {
    onSubmit () {
      this.$v.$touch()
      if (this.$v.phone.$invalid) return
      this.$store.dispatch('setUserPhoneInfo', {
        formattedPhone: this.phoneNumberInfo.formattedPhone,
        countryCode: this.phoneNumberInfo.countryCode,
        phone: this.phoneNumberInfo.phone
      })
        .then(() => {
          this.$store.commit('setUserPhone', this.phoneNumberInfo.phone.replaceAll(' ', ''))
          this.$router.push({ name: 'QidNumber' })
        })
    },
    onUpdatePhone (result) {
      this.$v.$reset()
      this.phoneNumberInfo.formattedPhone = result?.formattedNumber()
      this.phoneNumberInfo.isValidLength = result?.isValidLength()
      this.phoneNumberInfo.countryCode = result?.countryCode
    }
  },
  mounted () {
    this.phoneNumberInfo.phone = this.$store.getters.getUserPhoneInfo.phone
    this.phoneNumberInfo.countryCode = this.$store.getters.getUserPhoneInfo.countryCode || 'QA'
  },
  validations () {
    return {
      phone: {
        validPhone: () => this.phoneNumberInfo.isValidLength
      }
    }
  }
}
</script>
